import { DictionaryItem } from "@sa/rep-mdm";
import { produce } from "immer";
import { ICalendarItemDTO } from "../../../../../../api";
import type { IBulkBaseIndexControlAction, IBulkBaseIndexControlState } from "./BulkBaseIndexControl.types";

function getItemId(item?: DictionaryItem) {
  return item ? Number(item.id) : undefined;
}

export function reducer<T extends string | number | unknown>(state: IBulkBaseIndexControlState<T>, action: IBulkBaseIndexControlAction) {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case "initItems": {
      const { items, lastCalendarItems, isBulkSubscribtion, savedDateRange, selection, favoriteBulkId, tab, isCurrentFavouriteSettings } =
        payload.value as any;
      const controlItems = items as ICalendarItemDTO<string | number>[];
      const controlLastCalendarItems = lastCalendarItems as DictionaryItem[];
      const currentYear = new Date().getFullYear().toString();

      return produce(state, (draft) => {
        draft.availableDateRanges.forEach((dateRange) => {
          let filtredItems = controlItems.filter((it) => it.frequencyId === dateRange);

          const lastCalendarItem = controlLastCalendarItems.find((it) => it.getSingleValue("frequencyId") === dateRange);
          const lastItem = filtredItems[filtredItems.length - 1];
          const lastCalendarItemId = getItemId(lastCalendarItem) ?? lastItem?.id;
          filtredItems = filtredItems.filter((it) => Number(it.id) <= Number(lastCalendarItemId));

          const currentYearItem = filtredItems.find((e) => String(e.id).substring(1, 5).includes(currentYear));
          if (savedDateRange && (tab || favoriteBulkId || isCurrentFavouriteSettings || isBulkSubscribtion)) {
            draft.selectedRanges = [savedDateRange];
          }
          draft.lastCalendar[dateRange] = lastCalendarItemId as any;
          draft.items[dateRange] = filtredItems as any;
          draft.value[dateRange] = (
            (tab || favoriteBulkId || isCurrentFavouriteSettings || isBulkSubscribtion) && selection && dateRange === savedDateRange
              ? selection
              : currentYearItem?.id ?? lastCalendarItemId
          ) as any;
        });
      });
    }

    case "toggleDateRange": {
      const dateRangeIdentifier = payload.dateRange!;

      return produce(state, (draft) => {
        if (draft.availableDateRanges.length > 1) {
          if (!draft.selectedRanges.includes(dateRangeIdentifier)) {
            draft.selectedRanges = [dateRangeIdentifier];
          }
        }
      });
    }

    case "changeValue": {
      const { dateRange, value } = payload;
      const valueAs = value as any;

      if (valueAs === state.value[dateRange!]) {
        return state;
      }

      return produce(state, (draft) => {
        draft.value[dateRange!] = valueAs;
      });
    }

    default:
      throw new Error("Bulk calendar control cannot process the command");
  }
}
